module.exports = __webpack_public_path__ + "img/Initiative-on@3x.1b304284.png";